import React from "react";

/**
 * Completed View Component
 * Shows a thank-you message for colleague evaluations (user cannot see target's results)
 */
const CompletedView = ({ submission, assignment, onBack }) => {
  return (
    <div className="diagnostic-card completed-card">
      <div className="card-head">
        <h2 className="section-heading">Thank You!</h2>
        <div className="step-indicator">Completed</div>
      </div>

      <div className="completed-content">
        <div className="completed-icon">✓</div>
        <p className="completed-message">
          Your evaluation of <strong>{assignment.target?.firstName} {assignment.target?.lastName}</strong> has been submitted successfully.
        </p>
        <p className="completed-meta">
          <strong>Form:</strong> {submission.templateTitle || assignment.template?.title}
        </p>
        <p className="completed-meta">
          <strong>Submitted:</strong>{" "}
          {submission.submittedAt
            ? new Date(submission.submittedAt).toLocaleString()
            : "—"
          }
        </p>
        <p className="completed-hint">
          Your feedback will help {assignment.target?.firstName} understand their strengths and growth opportunities.
        </p>
      </div>

      <div className="nav-row">
        <button type="button" className="ghost-btn" onClick={onBack}>
          ← Back to Forms
        </button>
      </div>
    </div>
  );
};

export default CompletedView;
